<template>

</template>

<script>
export default {
  name: "gpsxt"
}
</script>

<style scoped>

</style>
